package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ConversionPathW500Rounded: ImageVector
    get() {
        if (_conversionPathW500Rounded != null) {
            return _conversionPathW500Rounded!!
        }
        _conversionPathW500Rounded = Builder(name = "ConversionPathW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(760.0f, 847.41f)
                quadToRelative(-42.59f, 0.0f, -75.14f, -24.41f)
                quadToRelative(-32.56f, -24.41f, -45.03f, -61.09f)
                lineTo(440.0f, 761.91f)
                quadToRelative(-66.72f, 0.0f, -114.32f, -47.59f)
                quadToRelative(-47.59f, -47.6f, -47.59f, -114.32f)
                quadToRelative(0.0f, -66.96f, 47.59f, -114.43f)
                quadToRelative(47.6f, -47.48f, 114.32f, -47.48f)
                horizontalLineToRelative(80.0f)
                quadToRelative(32.28f, 0.0f, 55.18f, -22.91f)
                quadToRelative(22.91f, -22.9f, 22.91f, -55.18f)
                reflectiveQuadToRelative(-22.91f, -55.18f)
                quadToRelative(-22.9f, -22.91f, -55.18f, -22.91f)
                lineTo(320.17f, 281.91f)
                quadToRelative(-13.24f, 36.68f, -45.41f, 61.09f)
                quadToRelative(-32.17f, 24.41f, -74.76f, 24.41f)
                quadToRelative(-53.11f, 0.0f, -90.26f, -37.15f)
                quadTo(72.59f, 293.11f, 72.59f, 240.0f)
                quadToRelative(0.0f, -53.11f, 37.15f, -90.26f)
                quadToRelative(37.15f, -37.15f, 90.26f, -37.15f)
                quadToRelative(42.59f, 0.0f, 74.76f, 24.41f)
                reflectiveQuadToRelative(45.41f, 61.09f)
                lineTo(520.0f, 198.09f)
                quadToRelative(66.96f, 0.0f, 114.43f, 47.48f)
                quadToRelative(47.48f, 47.47f, 47.48f, 114.43f)
                quadToRelative(0.0f, 66.96f, -47.48f, 114.43f)
                quadToRelative(-47.47f, 47.48f, -114.43f, 47.48f)
                horizontalLineToRelative(-80.0f)
                quadToRelative(-32.04f, 0.0f, -55.07f, 22.91f)
                quadToRelative(-23.02f, 22.9f, -23.02f, 55.18f)
                quadToRelative(0.0f, 32.04f, 23.02f, 55.07f)
                quadToRelative(23.03f, 23.02f, 55.07f, 23.02f)
                horizontalLineToRelative(199.83f)
                quadToRelative(13.24f, -36.68f, 45.41f, -61.09f)
                quadToRelative(32.17f, -24.41f, 74.76f, -24.41f)
                quadToRelative(53.11f, 0.0f, 90.26f, 37.15f)
                quadToRelative(37.15f, 37.15f, 37.15f, 90.26f)
                quadToRelative(0.0f, 53.11f, -37.15f, 90.26f)
                quadToRelative(-37.15f, 37.15f, -90.26f, 37.15f)
                close()
                moveTo(228.5f, 268.5f)
                quadTo(240.0f, 257.0f, 240.0f, 240.0f)
                reflectiveQuadToRelative(-11.5f, -28.5f)
                quadTo(217.0f, 200.0f, 200.0f, 200.0f)
                reflectiveQuadToRelative(-28.5f, 11.5f)
                quadTo(160.0f, 223.0f, 160.0f, 240.0f)
                reflectiveQuadToRelative(11.5f, 28.5f)
                quadTo(183.0f, 280.0f, 200.0f, 280.0f)
                reflectiveQuadToRelative(28.5f, -11.5f)
                close()
            }
        }
        .build()
        return _conversionPathW500Rounded!!
    }

private var _conversionPathW500Rounded: ImageVector? = null
